export const MAC_OS = navigator.appVersion.indexOf('Mac') !== -1
